import React, { useEffect, useState } from "react";
import styles from "./NotificationSettings.module.css"; // Make sure to have all styles in this file
import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom";
import { Switch, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import config from "../../../config";

const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    display: "flex",
    "&:active": {
        "& .MuiSwitch-thumb": {
            width: 20,
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
            transform: "translateX(20px)",
        },
    },
    "& .MuiSwitch-switchBase": {
        padding: 2,
        "&.Mui-checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "#001659", // Dark blue color for checked background
                opacity: 1,
                border: "none",
            },
        },
    },
    "& .MuiSwitch-thumb": {
        width: 22,
        height: 22,
        backgroundColor: "var(--color-secondary)", // Orange color for the switch knob
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        opacity: 1,
        backgroundColor: "#001659", // Dark blue color for unchecked background
        boxSizing: "border-box",
    },
}));

const NotificationSettings = () => {
    const navigate = useNavigate();
    const [isNotificationsEnabled, setIsNotificationsEnabled] = useState(false);

    useEffect(() => {
        document.title = `Notifications | ${config.get("COMPANY_NAME")}`;
    }, []);

    return (
        <>
            <Header title="Saved Searches" />
            <main className={styles.container}>
                <button onClick={() => navigate("/settings")} className={styles.backButton}>
                    <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/a3f4cc250003129920e6524c05797ad012534f9211075301316abedf7660e59c?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                        alt=""
                        className={styles.backIcon}
                    />
                    <span className={styles.backText}>Back to settings</span>
                </button>
                <section className={styles.content}>
                    <header className={styles.sectionHeader}>
                        <div className={styles.notifHeader}>
                            <h2 className={styles.sectionTitle}>Notifications</h2>
                            <p className={styles.sectionDescription}>
                                Receive notifications from Airebrokers to keep track of your home-buying journey, and you can disable them whenever
                                you wish.
                            </p>
                        </div>
                        <CustomSwitch
                            className={styles.iconSwitch}
                            checked={isNotificationsEnabled}
                            onChange={() => setIsNotificationsEnabled(!isNotificationsEnabled)}
                        />
                    </header>

                    <div className={styles.buttonContainer}>
                        <div className={styles.buttonWrapper}>
                            <button className={styles.locationButton}>
                                <span className={styles.locationName}>Home recommendations</span>
                                <CustomSwitch checked={isNotificationsEnabled} onChange={() => setIsNotificationsEnabled(!isNotificationsEnabled)} />
                            </button>
                            <p className={styles.sectionDescription}>Property suggestions tailored to your activity.</p>
                            <button className={styles.locationButton}>
                                <span className={styles.locationName}>Property updates</span>
                                <CustomSwitch checked={isNotificationsEnabled} onChange={() => setIsNotificationsEnabled(!isNotificationsEnabled)} />
                            </button>
                            <p className={styles.sectionDescription}>Notifications for updates on the properties you've saved.</p>
                            <button className={styles.locationButton}>
                                <span className={styles.locationName}>Market reports</span>
                                <CustomSwitch checked={isNotificationsEnabled} onChange={() => setIsNotificationsEnabled(!isNotificationsEnabled)} />
                            </button>
                            <p className={styles.sectionDescription}>In-depth market analysis for the areas where your saved homes are located.</p>
                            <button className={styles.locationButton}>
                                <span className={styles.locationName}>Property management resources</span>
                                <CustomSwitch checked={isNotificationsEnabled} onChange={() => setIsNotificationsEnabled(!isNotificationsEnabled)} />
                            </button>
                            <p className={styles.sectionDescription}>
                                Insights on market trends, along with tips and advice for landlords and property managers.
                            </p>
                            <button className={styles.locationButton}>
                                <span className={styles.locationName}>Tips, guides and product updates</span>
                                <CustomSwitch checked={isNotificationsEnabled} onChange={() => setIsNotificationsEnabled(!isNotificationsEnabled)} />
                            </button>
                            <p className={styles.sectionDescription}>
                                Real estate tips, Airebrokers guides, and unique news for buyers, renters, sellers, and homeowners.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default NotificationSettings;
